import React, { useState, useEffect } from 'react';
import Enumerable from 'linq';

//material mui
import { Card, CardHeader, Typography } from '@mui/material';

//state global
import { useGlobalState } from '../../Utilidades/useGlobalState';

//config
import { enlistaArrayCodigosMensajesIdiomas } from '../../Actions/Generales/IdiomasAction';
import { MostrarMensaje } from '../../Utilidades/ManejoMensajes';

//components
import Seleccion from './Admision/Seleccion';
import Requisitos from './Admision/Requisitos';
import RequisitosMultiple from './Admision/RequisitosMultiple';

//actions
import { ListadoAdjuntosRequisitos } from '../../Actions/Admisiones/AdmisionesReqAdjuntosAction';
import { ListadoRequisitosAdmisiones } from '../../Actions/Admisiones/AdmisionesRequisitosAction';
import { RequisitosAdmisionesMultiple } from '../../Actions/Admisiones/AdmisionesRequisitosAction'

import { dispatchAdmision, stateAdmison } from './Context/store'

//styles
import { StyleHome, StyleHomeHeader } from '../Tool/Style'
import { MOBILE } from './config';

const Admision = ({ deviceIs = "DESKTOP", Credenciales, AdmisionEstudiante, SetAdmisionEstudiante, SetRequisitosPendientes, SetAdmisionPreExistente, AdmisionPreExistente }) => {
    const [Admision, setAdmision] = useState('00000000-0000-0000-0000-000000000000');

    const admisionDispatch = dispatchAdmision()
    const { list } = stateAdmison();

    const [ListaRequisitosAdmision, setListaRequisitosAdmision] = useState([]); // se encarga del recolectar los Periodos academicos activos

    const { etiquetas , dispatch} = useGlobalState();

    useEffect(() => {
        setAdmision(AdmisionEstudiante)
    }, [AdmisionEstudiante]);

    const obtenerNombreAdjunto = async (id) => {
        if (id !== '00000000-0000-0000-0000-000000000000') {
            const objeto = {
                RequirementId: id
            };

            return ListadoAdjuntosRequisitos(objeto).then(response => {
                if (response.status === 200) //si la respuesta fue existosa 
                {
                    if (response.data.length > 0) {
                        return response.data[0].fileName;
                    }
                }
                else {
                    if (response.data.errors) {
                        const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                        MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
                    } else {
                        MostrarMensaje(dispatch, 'error', [response.statusText]);
                    }
                    return '';
                }
            });
        }
    };

    const funcionValidaRequisitosDeAdmision = async (idAdmision = '') => {
       
        const objetoListar = {
            AdmissionId: (idAdmision !== '' && idAdmision !== '00000000-0000-0000-0000-000000000000') ? idAdmision : Admision
        };        

        if (objetoListar.AdmissionId === '00000000-0000-0000-0000-000000000000') {
            setListaRequisitosAdmision([]);
            SetRequisitosPendientes(0);
            return;
        }

        const responseRequisitosAdmisionTable = await ListadoRequisitosAdmisiones(objetoListar);
        if (responseRequisitosAdmisionTable.status === 200) //si la respuesta fue existosa
        {
            const ListaRequisitosSinAdjuntos = Enumerable.from(responseRequisitosAdmisionTable.data).where(x => x.attachments === false && x.aprFileRequired === true && x.isRequired === true).toArray();
            SetRequisitosPendientes(ListaRequisitosSinAdjuntos.length);
            
            const attachments = Enumerable.from(responseRequisitosAdmisionTable.data).where(x => x.aprFileRequired === true || x.aprAcceptRequirement === true).toArray();
           
            if (attachments.length > 0) {
                let attachmentsTemp = []
                for (var i = 0; i < attachments.length; i++) {
                    const nombre = attachments[i].attachments === true ? await obtenerNombreAdjunto(attachments[i].adrRequirementId) : '';
                    attachmentsTemp.push({ ...attachments[i], ...{ fileName: nombre } });
                }
                setListaRequisitosAdmision(attachmentsTemp);
            }
            else {
                setListaRequisitosAdmision([]);
                SetRequisitosPendientes(0);
            }
        }
        else {
            if (response.data.errors) {
                const arrayErrores = enlistaArrayCodigosMensajesIdiomas(response.data.errors);
                MostrarMensaje(dispatch, response.data.typeError, arrayErrores);
            } else {
                MostrarMensaje(dispatch, 'error', [response.statusText]);
            }
            setListaRequisitosAdmision([]);
            SetRequisitosPendientes(0);
        }
    };

    //carga datos cuando no tiene admision es decir Admision = '00000000-0000-0000-0000-000000000000'
    const funcionCargaReqPrograma = (programId, admisionId) => {
        
        if (programId === '00000000-0000-0000-0000-000000000000') {
            admisionDispatch({
                type: 'changeArray',
                payload: { list: [] }
            })
            return;
         }
 
         if(admisionId !== '00000000-0000-0000-0000-000000000000'){
            return;            
         }

        const objReq = {
            ProgramId: programId,
            UserId: Credenciales.userId,
        }

        RequisitosAdmisionesMultiple(objReq).then(res => {

            const result = res.data.map(item => ({...item, fileDetail:null, aprAcceptedByStudent:false }))

            admisionDispatch({ 
                type:'changeArray',
                payload: { list: result } 
            })
            //setListaRequisitosAdmisionMultiple(res.data)
        })
    }

    // requisitos multiples [{ aprFileRequired:true, aprRequirementIdFk:"2123123", fileDetail:null, aprProgramReqId:"123", aprHyperlink:"", aprAcceptRequirement:true, aprAcceptedByStudent:true, attachments:true, requirementDsc:"descripcon", adrApproved:false}]
   
    //requisito data test [{ fileName:"nombre", aprFileRequired:true, aprRequirementIdFk:"2123123", fileDetail:null, aprProgramReqId:"123", aprHyperlink:"", aprAcceptRequirement:true, aprAcceptedByStudent:true, attachments:true, requirementDsc:"descripcon", adrApproved:false}]
    return (
        <div>
            <Card style={deviceIs === MOBILE ? { margin: '20px 12px',  padding: '0px 15px 15px'} : StyleHome.Card}>
                <CardHeader
                    style={{ paddingBottom: 0 }}
                    title={
                        <Typography style={{ ...StyleHomeHeader.HeaderText, ...{ fontSize: 24, textAlign: 'center', marginLeft: 0 } }}>
                            {etiquetas.Home.Et_lblSeleccion}
                        </Typography>} />
                
                <Seleccion
                    deviceIs={deviceIs}
                    setListaRequisitosAdmision={setListaRequisitosAdmision}
                    Admision={Admision} setAdmision={setAdmision}
                    FuncionValidaRequisitosDeAdmision={funcionValidaRequisitosDeAdmision} Credenciales={Credenciales}
                    SetAdmisionPreExistente={SetAdmisionPreExistente}
                    AdmisionPreExistente={AdmisionPreExistente}
                    funcionCargaReqPrograma={funcionCargaReqPrograma}
                />

            </Card>
            
                <Card style={deviceIs === MOBILE ? { margin: '20px 12px',  padding: '0px 6px 14px'} : StyleHome.Card}>
                    <CardHeader
                        style={{ paddingBottom: 0 }}
                        title={<Typography style={{ ...StyleHomeHeader.HeaderText, ...{ fontSize: 24, textAlign: 'center', marginLeft: 0 } }}>
                            {etiquetas.Home.Et_lblRequisitosAdmision}
                        </Typography>} />
                        
                        { Admision !== '00000000-0000-0000-0000-000000000000' ?
                            <Requisitos 
                              deviceIs={deviceIs}
                              Admision={Admision}
                              ListaRequisitosAdmision={ListaRequisitosAdmision}
                              FuncionValidaRequisitosDeAdmision={funcionValidaRequisitosDeAdmision}
                              Credenciales={Credenciales} 
                             />
                        :
                            <RequisitosMultiple 
                                deviceIs={deviceIs}
                                Admision={Admision} 
                                ListaRequisitosAdmision={list}
                                Credenciales={Credenciales} 
                                SetAdmision={setAdmision}
                                SetAdmisionPreExistente={SetAdmisionPreExistente}
                            /> 
                       }

                </Card>

        </div>
    );
};

export default Admision;